const styles = theme => ({

  filterField: {
    border: 'solid 1px red',
    width: 600
  }

})

export default styles;